<div class="dialog-header">
  <div class="header-title">
		<span style="font-size: 120%;">
      Edit Vehicle
		</span>
  </div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="dialog-content">
  <div class="dialog-block">
    <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}"
           [(ngModel)]="vehicle.name">
  </div>
  <div class="dialog-block">
    <p-dropdown [options]="users" [(ngModel)]="selectedUser" class="group-dropdown" [filter]="true"
                filterBy="name,username,shortCode,phone,email"
                placeholder="User"
                optionLabel="name" appendTo="body" panelStyleClass="p-vehicle-dropdown-panel">
    </p-dropdown>
  </div>
  <div class="dialog-block">
    <p-dropdown [options]="activityTypes" [(ngModel)]="selectedActivityType" class="group-dropdown"
                placeholder="Default Activity Type"
                optionLabel="title" appendTo="body" panelStyleClass="p-vehicle-dropdown-panel">
    </p-dropdown>
  </div>
  <div class="dialog-block">
    <p-dropdown [options]="vehicleStatuses" [(ngModel)]="selectedVehicleStatus" class="group-dropdown"
                placeholder="Status"
                optionLabel="title" appendTo="body" panelStyleClass="p-vehicle-dropdown-panel">
    </p-dropdown>
  </div>

  <div class="space-block">

  </div>
  <div class="save-button-block">
    <button (click)="saveVehicle()" mat-button class="save-button" mat-dialog-close
            [disabled]="!selectedVehicleStatus && !selectedUser"
            [ngClass]="{'disabled-button': !selectedVehicleStatus && !selectedUser}">
      <span *ngIf="!saveLoading">Save</span>
      <lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
    </button>
  </div>
</div>
